import React from 'react';
import { useForm } from 'react-hook-form';

import { CancelButton, FormButton } from '../../../../../components/Button';
import CustomDropdown from '../../../../../components/DropDown';
import { FormFieldset, Input, Textarea } from '../../../../../components/Form';
import Loader from '../../../../../components/Loader';
import { priority, status } from '../../__Test__/MockTasksheet';
import { IAddTaskSheet, ITaskSheetId } from '../../Tasksheet.props';
import useEditTaskSheet from './useEditTasksheet';

const EditTaskSheet: React.FC<ITaskSheetId> = ({ taskSheetId, setMethod }) => {
  const {
    loading,
    formData,
    handleChange,
    handleSubmit,
    setDefaultPriority,
    defaultPriority,
    defaultStatus,
    setDefaultStatus,
    setFormData,
    project,
    projectId,
    setProjectId,
  } = useEditTaskSheet(taskSheetId, setMethod);

  const { handleSubmit: useFormSubmit } = useForm<IAddTaskSheet>();

  const personalFields = [
    { label: "Description", name: "description", type: "textbox" },
    { label: "Query", name: "query", type: "textarea" },
    { label: "BackLog", name: "backLog", type: "textarea" },
  ] as const;
  return (
    <div className="flex flex-col items-center w-full h-full pr-8 pl-6 ">
      <div className="bg-white shadow-md rounded-lg pt-6 pb-6 w-full ">
        <div className="border-b-2 w-[100%]">
          <h1 className="text-3xl mb-2 text-fontBlack ml-5">Edit TaskSheet</h1>
        </div>
        {loading && <Loader />}
        <form
          onSubmit={useFormSubmit(handleSubmit)}
          className="space-y-6 p-6 h-[75vh] overflow-y-scroll"
        >
          <FormFieldset Ftitle="Personal Details">
            <div className="grid grid-cols-4 gap-6 m-4">
            {/* <CustomDropdown
                label="Project:"
                options={project}
                defaultOptionId={projectId}
                setDefaultOptionId={setProjectId}
                displayProperty="name"
                value={projectId}
                style="w-full"
              /> */}
              <CustomDropdown
                label="Priority:"
                options={priority}
                defaultOptionId={defaultPriority}
                setDefaultOptionId={setDefaultPriority}
                displayProperty="name"
                value={defaultPriority}
                style="w-full"
              />
              <CustomDropdown
                label="Status:"
                options={status}
                defaultOptionId={defaultStatus}
                setDefaultOptionId={setDefaultStatus}
                displayProperty="name"
                value={defaultStatus}
                style="w-full"
              />
            </div>
            <div className="grid grid-cols-3 gap-6 m-4">
              {personalFields.map((field) => (
                <Textarea
                key={field.name}
                name={field.name}
                label={field.label}
                value={formData[field.name]}
                onChange={handleChange}
              />
              ))}
              <div>
              <label className="text-fontBlack text-xs mb-2 flex">
                Due Date:
              </label>
              <input
                type="date"
                name="dueDate"
                className={`appearance-none border h-14 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline border-border`}
                value={
                  formData.dueDate
                    ? new Date(formData.dueDate).toISOString().split("T")[0]
                    : ""
                }
                onChange={(e) => {
                  handleChange(e);
                  setFormData({ ...formData, dueDate: e.target.value });
                }}
              />
              </div>
            </div>
          </FormFieldset>
          <div className="flex justify-center mt-6 ml-2 gap-3">
            <CancelButton
              className="py-2 px-4 h-[56px] w-[200.5px]"
              onClick={() => setMethod?.()}
              children="Cancel"
              type="button"
            />
            <FormButton
              className="py-2 px-4  h-[56px] w-[200.5px]"
              type="submit"
              children="Update"
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditTaskSheet;
